import { render, staticRenderFns } from "./onroute-deliveries.vue?vue&type=template&id=ec025bfc&scoped=true"
import script from "./onroute-deliveries.vue?vue&type=script&lang=js"
export * from "./onroute-deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec025bfc",
  null
  
)

export default component.exports